import { render } from "./ShellGenerate.vue?vue&type=template&id=a99d38d2"
import script from "./ShellGenerate.js?vue&type=script&lang=js"
export * from "./ShellGenerate.js?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__